import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import { Role } from '@/modules/auth/types';
import router, { ROUTE_NAME_APPLICATION } from './router';

menuRegistry.registerMenu([
    {
        parent: 'General',
        key: 'Application',
        name: 'Application',
        icon: 'fas fa-pen-square',
        route: { name: ROUTE_NAME_APPLICATION.INDEX },
        roles: [Role.ADMIN]
    }
]);

export default registerRouteForModule(router);
